<template>
  <div class="notification is-info">
    <div v-if="alert.message" :class="`alert ${alert.type}`">
      {{ alert.message }}

    </div>
   
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
//import router from '../router'

export default {
  name: "AlertMessages",
  computed: {
    ...mapState({      alert: state => state.alert    })
  },
  methods: {
    ...mapActions("alert", ["clear"])
  },
//   beforeRouteUpdate () {
//       // clear alert on location change
//      // if(to!=from)
//       this.clear();
//   }
};
</script>

<style lang="scss"></style>
